// extracted by mini-css-extract-plugin
export default {"flag":"finance_flags_flag"};